const colors = {
    primaryColor: '#D6D6D6', // light gray 
    secondaryColor: '#FAFAFA', // almost white
    tertiaryColor: '#FFDB70', // yellow color
  };
  
  export default colors;